// UI actions
export const UPDATE_DELIVERY_RADIUS =
  'deliveryAreas.list.UPDATE_DELIVERY_RADIUS';
export const DISCARD_DELIVERY_RADIUS =
  'deliveryAreas.list.DISCARD_DELIVERY_RADIUS';
export const SET_SELECTED_AREA = 'deliveryAreas.list.SET_SELECTED_AREA';
export const UPDATE_SELECTED_AREA = 'deliveryAreas.list.UPDATE_SELECTED_AREA';
export const DISCARD_SELECTED_AREA = 'deliveryAreas.list.DISCARD_SELECTED_AREA';

export type UPDATE_DELIVERY_RADIUS = typeof UPDATE_DELIVERY_RADIUS;
export type DISCARD_DELIVERY_RADIUS = typeof DISCARD_DELIVERY_RADIUS;
export type SET_SELECTED_AREA = typeof SET_SELECTED_AREA;
export type UPDATE_SELECTED_AREA = typeof UPDATE_SELECTED_AREA;
export type DISCARD_SELECTED_AREA = typeof DISCARD_SELECTED_AREA;

// API actions
export const API_READ_DELIVERY_AREAS =
  'deliveryAreas.list.API_READ_DELIVERY_AREAS';
export const API_READ_DELIVERY_AREAS_REQUEST =
  'deliveryAreas.list.API_READ_DELIVERY_AREAS_REQUEST';
export const API_READ_DELIVERY_AREAS_SUCCESS =
  'deliveryAreas.list.API_READ_DELIVERY_AREAS_SUCCESS';
export const API_READ_DELIVERY_AREAS_FAILURE =
  'deliveryAreas.list.API_READ_DELIVERY_AREAS_FAILURE';

export const API_READ_BLUEPRINT_AREAS =
  'deliveryAreas.list.API_READ_BLUEPRINT_AREAS';
export const API_READ_BLUEPRINT_AREAS_REQUEST =
  'deliveryAreas.list.API_READ_BLUEPRINT_AREAS_REQUEST';
export const API_READ_BLUEPRINT_AREAS_SUCCESS =
  'deliveryAreas.list.API_READ_BLUEPRINT_AREAS_SUCCESS';
export const API_READ_BLUEPRINT_AREAS_FAILURE =
  'deliveryAreas.list.API_READ_BLUEPRINT_AREAS_FAILURE';

export const API_READ_DELIVERY_RADIUS =
  'deliveryAreas.list.API_READ_DELIVERY_RADIUS';
export const API_READ_DELIVERY_RADIUS_REQUEST =
  'deliveryAreas.list.API_READ_DELIVERY_RADIUS_REQUEST';
export const API_READ_DELIVERY_RADIUS_SUCCESS =
  'deliveryAreas.list.API_READ_DELIVERY_RADIUS_SUCCESS';
export const API_READ_DELIVERY_RADIUS_FAILURE =
  'deliveryAreas.list.API_READ_DELIVERY_RADIUS_FAILURE';

export const API_SAVE_DELIVERY_RADIUS =
  'deliveryAreas.list.API_SAVE_DELIVERY_RADIUS';
export const API_SAVE_DELIVERY_RADIUS_REQUEST =
  'deliveryAreas.list.API_SAVE_DELIVERY_RADIUS_REQUEST';
export const API_SAVE_DELIVERY_RADIUS_SUCCESS =
  'deliveryAreas.list.API_SAVE_DELIVERY_RADIUS_SUCCESS';
export const API_SAVE_DELIVERY_RADIUS_FAILURE =
  'deliveryAreas.list.API_SAVE_DELIVERY_RADIUS_FAILURE';

export const API_CREATE_DELIVERY_AREA =
  'deliveryAreas.list.API_CREATE_DELIVERY_AREA';
export const API_CREATE_DELIVERY_AREA_REQUEST =
  'deliveryAreas.list.API_CREATE_DELIVERY_AREA_REQUEST';
export const API_CREATE_DELIVERY_AREA_SUCCESS =
  'deliveryAreas.list.API_CREATE_DELIVERY_AREA_SUCCESS';
export const API_CREATE_DELIVERY_AREA_FAILURE =
  'deliveryAreas.list.API_CREATE_DELIVERY_AREA_FAILURE';

export const API_SAVE_DELIVERY_AREA =
  'deliveryAreas.list.API_SAVE_DELIVERY_AREA';
export const API_SAVE_DELIVERY_AREA_REQUEST =
  'deliveryAreas.list.API_SAVE_DELIVERY_AREA_REQUEST';
export const API_SAVE_DELIVERY_AREA_SUCCESS =
  'deliveryAreas.list.API_SAVE_DELIVERY_AREA_SUCCESS';
export const API_SAVE_DELIVERY_AREA_FAILURE =
  'deliveryAreas.list.API_SAVE_DELIVERY_AREA_FAILURE';

export const API_SAVE_MAIN_DELIVERY_AREA =
  'deliveryAreas.list.API_SAVE_MAIN_DELIVERY_AREA';
export const API_SAVE_MAIN_DELIVERY_AREA_REQUEST =
  'deliveryAreas.list.API_SAVE_MAIN_DELIVERY_AREA_REQUEST';
export const API_SAVE_MAIN_DELIVERY_AREA_SUCCESS =
  'deliveryAreas.list.API_SAVE_MAIN_DELIVERY_AREA_SUCCESS';
export const API_SAVE_MAIN_DELIVERY_AREA_FAILURE =
  'deliveryAreas.list.API_SAVE_MAIN_DELIVERY_AREA_FAILURE';

export const API_RECREATE_DELIVERY_AREA =
  'deliveryAreas.list.API_RECREATE_DELIVERY_AREA';
export const API_RECREATE_DELIVERY_AREA_REQUEST =
  'deliveryAreas.list.API_RECREATE_DELIVERY_AREA_REQUEST';
export const API_RECREATE_DELIVERY_AREA_SUCCESS =
  'deliveryAreas.list.API_RECREATE_DELIVERY_AREA_SUCCESS';
export const API_RECREATE_DELIVERY_AREA_FAILURE =
  'deliveryAreas.list.API_RECREATE_DELIVERY_AREA_FAILURE';

export const API_READ_DELIVERY_AREAS_SETTINGS =
  'deliveryAreas.list.API_READ_DELIVERY_AREAS_SETTINGS';
export const API_READ_DELIVERY_AREAS_SETTINGS_REQUEST =
  'deliveryAreas.list.API_READ_DELIVERY_AREAS_SETTINGS_REQUEST';
export const API_READ_DELIVERY_AREAS_SETTINGS_SUCCESS =
  'deliveryAreas.list.API_READ_DELIVERY_AREAS_SETTINGS_SUCCESS';
export const API_READ_DELIVERY_AREAS_SETTINGS_FAILURE =
  'deliveryAreas.list.API_READ_DELIVERY_AREAS_SETTINGS_FAILURE';

export const API_DELETE_DELIVERY_AREA =
  'deliveryAreas.detail.API_DELETE_DELIVERY_AREA';
export const API_DELETE_DELIVERY_AREA_REQUEST =
  'deliveryAreas.detail.API_DELETE_DELIVERY_AREA_REQUEST';
export const API_DELETE_DELIVERY_AREA_SUCCESS =
  'deliveryAreas.detail.API_DELETE_DELIVERY_AREA_SUCCESS';
export const API_DELETE_DELIVERY_AREA_FAILURE =
  'deliveryAreas.detail.API_DELETE_DELIVERY_AREA_FAILURE';

export type API_READ_DELIVERY_AREAS = typeof API_READ_DELIVERY_AREAS;
export type API_READ_DELIVERY_AREAS_REQUEST =
  typeof API_READ_DELIVERY_AREAS_REQUEST;
export type API_READ_DELIVERY_AREAS_SUCCESS =
  typeof API_READ_DELIVERY_AREAS_SUCCESS;
export type API_READ_DELIVERY_AREAS_FAILURE =
  typeof API_READ_DELIVERY_AREAS_FAILURE;

export type API_READ_BLUEPRINT_AREAS = typeof API_READ_BLUEPRINT_AREAS;
export type API_READ_BLUEPRINT_AREAS_REQUEST =
  typeof API_READ_BLUEPRINT_AREAS_REQUEST;
export type API_READ_BLUEPRINT_AREAS_SUCCESS =
  typeof API_READ_BLUEPRINT_AREAS_SUCCESS;
export type API_READ_BLUEPRINT_AREAS_FAILURE =
  typeof API_READ_BLUEPRINT_AREAS_FAILURE;

export type API_READ_DELIVERY_RADIUS = typeof API_READ_DELIVERY_RADIUS;
export type API_READ_DELIVERY_RADIUS_REQUEST =
  typeof API_READ_DELIVERY_RADIUS_REQUEST;
export type API_READ_DELIVERY_RADIUS_SUCCESS =
  typeof API_READ_DELIVERY_RADIUS_SUCCESS;
export type API_READ_DELIVERY_RADIUS_FAILURE =
  typeof API_READ_DELIVERY_RADIUS_FAILURE;

export type API_SAVE_DELIVERY_RADIUS = typeof API_SAVE_DELIVERY_RADIUS;
export type API_SAVE_DELIVERY_RADIUS_REQUEST =
  typeof API_SAVE_DELIVERY_RADIUS_REQUEST;
export type API_SAVE_DELIVERY_RADIUS_SUCCESS =
  typeof API_SAVE_DELIVERY_RADIUS_SUCCESS;
export type API_SAVE_DELIVERY_RADIUS_FAILURE =
  typeof API_SAVE_DELIVERY_RADIUS_FAILURE;

export type API_SAVE_DELIVERY_AREA = typeof API_SAVE_DELIVERY_AREA;
export type API_SAVE_DELIVERY_AREA_REQUEST =
  typeof API_SAVE_DELIVERY_AREA_REQUEST;
export type API_SAVE_DELIVERY_AREA_SUCCESS =
  typeof API_SAVE_DELIVERY_AREA_SUCCESS;
export type API_SAVE_DELIVERY_AREA_FAILURE =
  typeof API_SAVE_DELIVERY_AREA_FAILURE;

export type API_SAVE_MAIN_DELIVERY_AREA = typeof API_SAVE_MAIN_DELIVERY_AREA;
export type API_SAVE_MAIN_DELIVERY_AREA_REQUEST =
  typeof API_SAVE_MAIN_DELIVERY_AREA_REQUEST;
export type API_SAVE_MAIN_DELIVERY_AREA_SUCCESS =
  typeof API_SAVE_MAIN_DELIVERY_AREA_SUCCESS;
export type API_SAVE_MAIN_DELIVERY_AREA_FAILURE =
  typeof API_SAVE_MAIN_DELIVERY_AREA_FAILURE;

export type API_RECREATE_DELIVERY_AREA = typeof API_RECREATE_DELIVERY_AREA;
export type API_RECREATE_DELIVERY_AREA_REQUEST =
  typeof API_RECREATE_DELIVERY_AREA_REQUEST;
export type API_RECREATE_DELIVERY_AREA_SUCCESS =
  typeof API_RECREATE_DELIVERY_AREA_SUCCESS;
export type API_RECREATE_DELIVERY_AREA_FAILURE =
  typeof API_RECREATE_DELIVERY_AREA_FAILURE;

export type API_READ_DELIVERY_AREAS_SETTINGS =
  typeof API_READ_DELIVERY_AREAS_SETTINGS;
export type API_READ_DELIVERY_AREAS_SETTINGS_REQUEST =
  typeof API_READ_DELIVERY_AREAS_SETTINGS_REQUEST;
export type API_READ_DELIVERY_AREAS_SETTINGS_SUCCESS =
  typeof API_READ_DELIVERY_AREAS_SETTINGS_SUCCESS;
export type API_READ_DELIVERY_AREAS_SETTINGS_FAILURE =
  typeof API_READ_DELIVERY_AREAS_SETTINGS_FAILURE;

export type API_CREATE_DELIVERY_AREA = typeof API_CREATE_DELIVERY_AREA;
export type API_CREATE_DELIVERY_AREA_REQUEST =
  typeof API_CREATE_DELIVERY_AREA_REQUEST;
export type API_CREATE_DELIVERY_AREA_SUCCESS =
  typeof API_CREATE_DELIVERY_AREA_SUCCESS;
export type API_CREATE_DELIVERY_AREA_FAILURE =
  typeof API_CREATE_DELIVERY_AREA_FAILURE;

export type API_DELETE_DELIVERY_AREA = typeof API_DELETE_DELIVERY_AREA;
export type API_DELETE_DELIVERY_AREA_REQUEST =
  typeof API_DELETE_DELIVERY_AREA_REQUEST;
export type API_DELETE_DELIVERY_AREA_SUCCESS =
  typeof API_DELETE_DELIVERY_AREA_SUCCESS;
export type API_DELETE_DELIVERY_AREA_FAILURE =
  typeof API_DELETE_DELIVERY_AREA_FAILURE;
